import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, FileText } from "lucide-react";

// Fetches an authenticated file as a blob and renders it.
// For PDFs, shows a file badge that opens the blob in a new tab.
export function AuthedImage({ fileId, filename = "", className = "", alt = "reference" }) {
  const [url, setUrl] = useState(null);
  const [type, setType] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    let objUrl;
    let active = true;
    if (!fileId) return;
    api
      .get(`/files/${fileId}`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        objUrl = URL.createObjectURL(res.data);
        setUrl(objUrl);
        setType(res.data.type || "");
      })
      .catch(() => active && setError(true));
    return () => {
      active = false;
      if (objUrl) URL.revokeObjectURL(objUrl);
    };
  }, [fileId]);

  if (error) {
    return (
      <div className={`flex items-center justify-center bg-slate-50 text-slate-400 text-xs ${className}`}>
        unavailable
      </div>
    );
  }
  if (!url) {
    return (
      <div className={`flex items-center justify-center bg-slate-50 ${className}`}>
        <Loader2 className="w-4 h-4 animate-spin text-slate-400" />
      </div>
    );
  }
  if (type.includes("pdf") || filename.toLowerCase().endsWith(".pdf")) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className={`flex flex-col items-center justify-center bg-slate-50 text-slate-600 hover:text-blue-600 text-[11px] gap-1 ${className}`}
      >
        <FileText className="w-5 h-5" />
        <span className="truncate max-w-full px-1">{filename || "View PDF"}</span>
      </a>
    );
  }
  return <img src={url} alt={alt} className={className} />;
}
